export enum columnStereotypeValue {
	VIRTUAL_COLUMN = 37
}
